import * as React from 'react';
import PlayerSelector from './basic/PlayerSelector';
import gameService from '../../../services/game.service';

export default function SelectMainPlayers({ homeTeam, awayTeam, updateGamePlayers, game, setGamePlayerRefresh }) {
    const [posList, setPosList] = React.useState([]);
    React.useEffect(() => {
        gameService.getAllPositions().then((res) => {
            setPosList(res);
        });
    }, []);
    return (
        <>
            <PlayerSelector title="Home Team" playerList={homeTeam} updateGamePlayers={updateGamePlayers.updateHomePlayers} game={game} posList={posList} setGamePlayerRefresh={setGamePlayerRefresh} onSelect={(player) => {}} />

            <PlayerSelector title="Away Team" playerList={awayTeam} updateGamePlayers={updateGamePlayers.updateAwayPlayers} game={game} posList={posList} setGamePlayerRefresh={setGamePlayerRefresh} onSelect={(player) => {}} />
        </>
    );
}
